// extracted by mini-css-extract-plugin
export default {"wrapper":"G6-z"};